export default __webpack_public_path__ + "static/media/layered-waves-haikei-7.81a01898.svg";